import React, { useEffect, useState, useRef } from "react";
import { Button, Card, Collapse, Form, Modal } from "react-bootstrap";
import { adminReqConfig, api } from "../../include/api";
import { ERROR, SUCCESS } from "../../include/constant";
import { useNotification } from "../../Toast/ToastProvider";
import AdminHeader from "../admin/Header";

// ✅ SettingsCard - Only renders the collapsible form section
const SettingsCard = ({
  index,
  formData,
  handleChange,
  handleSubmit,
  open,
  toggleOpen,
  header,
  data,
  toast,
  onEditDelete,
  setCards,
  cards,
}) => {
  formData.head = header;

  const handleSetEditValues = (id) => {
    let editObj = data.find((d) => String(d.id) === String(id));
    setCards(
      cards.map((card, i) =>
        i === index ? { ...card, formData: editObj } : card,
      ),
    );
  };

  return (
    <>
      <Card className="m-3">
        <Card.Header>
          <Button
            className="fs-5 fw-bold"
            variant="link"
            onClick={() => toggleOpen(index)}
            aria-controls={`collapse-form-${index}`}
            aria-expanded={open}
          >
            <div className={`p-3 ${open ? "text-success" : "text-dark"}`}>
              {header}
            </div>
          </Button>
        </Card.Header>
        <Collapse in={open}>
          <div id={`collapse-form-${index}`}>
            <div className="row ms-2">
              {data?.map((d, i) => (
                <SettingsView
                  settings={d}
                  key={i}
                  onEditDelete={onEditDelete}
                  toast={toast}
                  handleSetEditValues={() => handleSetEditValues(d.id)}
                />
              ))}
            </div>
            <Card.Body>
              <Form onSubmit={(e) => handleSubmit(e, index)}>
                <Form.Group controlId={`formHead-${index}`}>
                  <Form.Label>Head</Form.Label>
                  <Form.Control
                    type="text"
                    name="head"
                    value={formData?.head || ""}
                    onChange={(e) => handleChange(e, index)}
                    placeholder="Enter head"
                    required
                  />
                </Form.Group>

                <Form.Group controlId={`formKey-${index}`} className="mt-3">
                  <Form.Label>Key</Form.Label>
                  <Form.Control
                    type="text"
                    name="key"
                    value={formData?.key || ""}
                    onChange={(e) => handleChange(e, index)}
                    placeholder="Enter key"
                    required
                  />
                </Form.Group>

                <Form.Group controlId={`formValue-${index}`} className="mt-3">
                  <Form.Label>Value</Form.Label>
                  <Form.Control
                    type="text"
                    name="value"
                    value={formData?.value || ""}
                    onChange={(e) => handleChange(e, index)}
                    placeholder="Enter value"
                    required
                  />
                </Form.Group>

                <Button variant="primary" type="submit" className="mt-4">
                  {formData?.id ? "Update" : "Save"}
                </Button>
              </Form>
            </Card.Body>
          </div>
        </Collapse>
      </Card>
    </>
  );
};

// ✅ SettingsView - Individual setting item display
const SettingsView = ({
  settings,
  onEditDelete,
  toast,
  handleSetEditValues,
}) => {
  const handleDeleteSettings = () => {
    if (settings.id) {
      api
        .delete("/settings/?id=" + settings.id, adminReqConfig())
        .then((response) => {
          if (response.status === 200) {
            toast({ type: SUCCESS, message: response.data.message });
            onEditDelete();
          }
        })
        .catch((error) => {
          error.response
            ? toast({ type: ERROR, message: error.response.data.message })
            : toast({ type: ERROR, message: error.message });
        })
        .finally();
    }
  };

  const handleEditSettings = () => {
    handleSetEditValues();
  };

  return (
    <div className="col-12 col-md-6 col-lg-4 col-xl-3 p-2">
      <div className="border shadow-sm p-2">
        <h6 className="d-flex align-items-center justify-content-between fw-bold">
          <div className="text-truncate">
            <i
              className={`fas fa-circle blink text-success`}
              style={{ fontSize: ".7rem" }}
            />
            <span className="ps-2 fs-5">{settings.head}</span>
          </div>
          <span className="small d-flex align-items-center">
            <i
              className="fas fa-pencil-alt fa-sm p-2 text-primary cursor-pointer"
              onClick={handleEditSettings}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Edit"
            />
            <i
              className="fas fa-trash-alt fa-sm ps-2 text-danger cursor-pointer"
              onClick={handleDeleteSettings}
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Delete"
            />
          </span>
        </h6>
        <hr className="my-2" />
        <p className="small mb-1 text-muted">
          <i className="fas fa-key fa-md fa-fw text-primary" />
          <span className="ps-2 text-truncate">{settings.key}</span>
        </p>
        <p className="small mb-1 text-muted">
          <i className="fas fa-square-check fa-md fa-fw text-primary" />
          <span className="ps-2 text-truncate">{settings.value}</span>
        </p>
      </div>
    </div>
  );
};

// ✅ QuickAccessCards - Top cards that trigger table view
const QuickAccessCards = ({
  cards,
  setCards,
  onSelectCategory,
  selectedCategory,
}) => {
  const selectedCustomerType =
    selectedCategory === "Payment Methods"
      ? "b2b"
      : selectedCategory === "Shipping Methods"
        ? "b2c"
        : "all";

  const handleCardClick = (targetHeader) => {
    const cardIndex = cards.findIndex((card) => card.head === targetHeader);
    if (cardIndex !== -1) {
      setCards(
        cards.map((card, i) =>
          i === cardIndex ? { ...card, open: !card.open } : card,
        ),
      );
    }
    onSelectCategory(targetHeader);
  };

  return (
    <div className="row m-3">
      <div className="col my-22 ms-22">
        <div
          className={`shadow-lg ${
            selectedCustomerType === "b2b"
              ? "selected-order-list-card"
              : "order-list-card"
          }`}
          onClick={() => handleCardClick("Payment Methods")}
          style={{ cursor: "pointer" }}
        >
          <div className="d-flex gap-10">
            <div className="order-list-card-image p-2">
              <img
                src="/assets/images/recieved-pay.png"
                style={{ height: "50px", width: "50px" }}
                alt="Payment"
              />
            </div>
            <div>
              <h6 className="order-list-amnt ms-8 mt-22">Payment Methods</h6>
            </div>
          </div>
        </div>
      </div>
      <div className="col my-22 me-22">
        <div
          className={`shadow-lg ${
            selectedCustomerType === "b2c"
              ? "selected-order-list-card"
              : "order-list-card"
          }`}
          onClick={() => handleCardClick("Shipping Methods")}
          style={{ cursor: "pointer" }}
        >
          <div className="d-flex gap-10">
            <div className="order-list-card-image p-2">
              <img
                src="/assets/images/ord-shipped.png"
                style={{ height: "50px", width: "50px" }}
                alt="shipping"
              />
            </div>
            <div>
              <h6
                className="order-list-amnt ms-8 mt-22"
                style={{ color: "#2B95D3" }}
              >
                Shipping Methods
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// ✅ SettingsTable - Table view for selected category with Add/Edit/Delete
const SettingsTable = ({ category, data, onEdit, onDelete, onAdd }) => {
  return (
    <div
      className="ps-22 pe-22 pb-22 rounded-5"
      style={{ backgroundColor: "#fff", margin: "0 12px" }}
    >
      <div className="row align-items-center pt-32 pb-10">
        <div className="col-auto">
          <h6 className="mb-0">{category} List</h6>
        </div>
        <div className="col-auto d-flex align-items-center gap-2 ms-auto">
          <button
            className="btn"
            style={{
              height: "40px",
              width: "140px",
              color: "white",
              backgroundColor: "#2696D5",
              border: "none",
              borderRadius: "6px",
            }}
            onClick={onAdd}
          >
            Add New
          </button>
        </div>
      </div>

      <div className="table-responsive mt-24">
        <table className="table table-striped custom-striped-table-product-list align-middle">
          <thead>
            <tr>
              <th scope="col">Key</th>
              <th scope="col">Value</th>
              <th scope="col" style={{ width: "120px" }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {data && data.length > 0 ? (
              data.map((item) => (
                <tr key={item.id}>
                  <td style={{ textWrap: "nowrap", overflow: "hidden" }}>
                    {item.key}
                  </td>
                  <td>
                    <div
                      style={{
                        maxWidth: "200px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {item.value || "-"}
                    </div>
                  </td>
                  <td style={{ position: "relative" }}>
                    <div className="d-flex gap-1">
                      <button
                        style={{
                          backgroundColor: "#d9ebff",
                          height: "39px",
                          width: "50px",
                          border: "none",
                          borderRadius: "4px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: "pointer",
                          padding: "0",
                          margin: "0",
                        }}
                        onClick={() => onEdit(item)}
                      >
                        <img
                          src="/assets/images/edit-icon.png"
                          alt="Edit"
                          style={{
                            width: "16px",
                            height: "16px",
                            objectFit: "contain",
                          }}
                          onError={(e) => (e.target.style.display = "none")}
                        />
                      </button>
                      <button
                        style={{
                          backgroundColor: "#d9ebff",
                          height: "39px",
                          width: "50px",
                          border: "none",
                          borderRadius: "4px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          cursor: "pointer",
                          padding: "0",
                          margin: "0",
                        }}
                        onClick={() => onDelete(item.id)}
                      >
                        <img
                          src="/assets/images/delete-icon.png"
                          alt="Delete"
                          style={{
                            width: "16px",
                            height: "16px",
                            objectFit: "contain",
                          }}
                          onError={(e) => (e.target.style.display = "none")}
                        />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="text-center py-4">
                  No data found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// ✅ SettingsModal - Modal for Add/Edit (Updated with Loading Spinner)
const SettingsModal = ({
  show,
  handleClose,
  handleSubmit,
  formData,
  handleChange,
  isEdit,
  category,
  saving,
}) => {
  // ✅ Spinner component (same style as AddBrand)
  const renderLoadingSpinner = () => (
    <i
      className="fa fa-spinner fa-spin me-2"
      aria-hidden="true"
      style={{ fontSize: "0.9rem" }}
    />
  );

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <button
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "15px",
              right: "12px",
              width: "32px",
              height: "32px",
              background: "none",
              border: "3px solid #ddd",
              borderRadius: "50%",
              fontSize: "28px",
              cursor: "pointer",
              color: "#6E7C94",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: 0,
            }}
          >
            &times;
          </button>
          <h6
            style={{
              marginBottom: "15px",
              fontWeight: "700",
              fontSize: "20px",
              marginTop: "15px",
            }}
          >
            {isEdit ? "Edit" : "Add New"} - {category}
          </h6>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <Form.Group controlId="formKey" className="mb-16">
              <Form.Label>Key</Form.Label>
              <Form.Control
                type="text"
                name="key"
                value={formData?.key || ""}
                onChange={handleChange}
                placeholder="Enter key"
                required
                disabled={saving}
              />
            </Form.Group>

            <Form.Group controlId="formValue" className="mb-16">
              <Form.Label>Value</Form.Label>
              <Form.Control
                type="text"
                name="value"
                value={formData?.value || ""}
                onChange={handleChange}
                placeholder="Enter value"
                required
                disabled={saving}
              />
            </Form.Group>

            <div className="d-flex justify-content-end gap-2">
              <Button
                variant="secondary"
                onClick={handleClose}
                disabled={saving}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                type="submit"
                disabled={saving}
                style={{
                  display: "flex",
                  alignItems: "center",
                  opacity: saving ? 0.7 : 1,
                  cursor: saving ? "not-allowed" : "pointer",
                }}
              >
                {saving ? (
                  <>
                    {renderLoadingSpinner()}
                    {isEdit ? "Updating..." : "Adding..."}
                  </>
                ) : isEdit ? (
                  "Update"
                ) : (
                  "Save"
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

// ✅ Main SettingsList Component
const SettingsList = () => {
  const toast = useNotification();
  const [settingsData, setSettingsData] = useState([]);
  const [cards, setCards] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("Payment Methods");

  // Modal states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalFormData, setModalFormData] = useState({
    head: "",
    key: "",
    value: "",
  });
  const [isEdit, setIsEdit] = useState(false);
  // ✅ CHANGE: Add saving state for loading indicator
  const [saving, setSaving] = useState(false);

  // Initialize cards based on settings data
  useEffect(() => {
    let heads = [...new Set(settingsData.map((s) => s.head))].sort((a, b) =>
      a.localeCompare(b),
    );

    let array = [];
    if (heads.length > 2) {
      heads.forEach((h) => {
        array.push({
          head: h,
          open: false,
          formData: { head: "", key: "", value: "" },
        });
      });
    }
    setCards(array);
  }, [settingsData]);

  // Fetch settings data from API
  const getSettingsdata = () => {
    api
      .get("/settings/", adminReqConfig())
      .then((response) => {
        if (response.status === 200) {
          setSettingsData(response.data.data);
        }
      })
      .catch((error) => {
        setSettingsData([]);
      });
  };

  useEffect(() => {
    getSettingsdata();
  }, []);

  // Toggle collapse for old card view
  const toggleOpen = (index) => {
    setCards(
      cards.map((card, i) =>
        i === index ? { ...card, open: !card.open } : card,
      ),
    );
  };

  // Handle category selection from QuickAccessCards
  const handleSelectCategory = (category) => {
    setSelectedCategory(category);
  };

  // Handle form change for modal
  const handleModalChange = (e) => {
    const { name, value } = e.target;
    setModalFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Add New click
  const handleAddNew = () => {
    setIsEdit(false);
    setModalFormData({ head: selectedCategory, key: "", value: "" });
    setIsModalOpen(true);
  };

  // Handle Edit click
  const handleEditClick = (item) => {
    setIsEdit(true);
    setModalFormData({
      head: item.head,
      key: item.key,
      value: item.value,
      id: item.id,
    });
    setIsModalOpen(true);
  };

  // Handle Delete
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this setting?")) {
      api
        .delete("/settings/?id=" + id, adminReqConfig())
        .then((response) => {
          if (response.status === 200) {
            toast({ type: SUCCESS, message: response.data.message });
            getSettingsdata();
          }
        })
        .catch((error) => {
          error.response
            ? toast({ type: ERROR, message: error.response.data.message })
            : toast({ type: ERROR, message: error.message });
        });
    }
  };

  // Handle modal form submit (Updated with saving state)
  const handleModalSubmit = () => {
    if (!modalFormData.key || !modalFormData.value) {
      toast({ type: ERROR, message: "Key and Value are required" });
      return;
    }

    const payload = {
      head: selectedCategory,
      key: modalFormData.key,
      value: modalFormData.value,
    };

    // ✅ Set saving to true before API call
    setSaving(true);

    if (isEdit && modalFormData.id) {
      // Update existing
      api
        .put(`/settings/?id=${modalFormData.id}`, payload, adminReqConfig())
        .then((response) => {
          if (response.status === 200) {
            toast({ type: SUCCESS, message: response.data.message });
            getSettingsdata();
            handleCloseModal();
          }
        })
        .catch((error) => {
          error.response
            ? toast({ type: ERROR, message: error.response.data.message })
            : toast({ type: ERROR, message: error.message });
        })
        .finally(() => {
          // ✅ Reset saving after API call completes
          setSaving(false);
        });
    } else {
      // Create new
      api
        .post("/settings/", payload, adminReqConfig())
        .then((response) => {
          if (response.status === 200) {
            toast({ type: SUCCESS, message: response.data.message });
            getSettingsdata();
            handleCloseModal();
          }
        })
        .catch((error) => {
          error.response
            ? toast({ type: ERROR, message: error.response.data.message })
            : toast({ type: ERROR, message: error.message });
        })
        .finally(() => {
          // ✅ Reset saving after API call completes
          setSaving(false);
        });
    }
  };

  // Close modal
  const handleCloseModal = () => {
    setIsModalOpen(false);
    setModalFormData({ head: "", key: "", value: "" });
    setIsEdit(false);
  };

  // Filter data for selected category
  const filteredData = selectedCategory
    ? settingsData.filter((item) => item.head === selectedCategory)
    : [];

  // Handle form change for old card view (keep for backward compatibility)
  const handleChange = (e, index) => {
    const { name, value } = e.target;
    setCards(
      cards.map((card, i) =>
        i === index
          ? { ...card, formData: { ...card.formData, [name]: value } }
          : card,
      ),
    );
  };

  // Handle form submit for old card view (keep for backward compatibility)
  const handleSubmit = (e, index) => {
    e.preventDefault();
    const formData = cards[index].formData;

    if (formData.id) {
      api
        .put(`/settings/?id=${formData.id}`, formData, adminReqConfig())
        .then((response) => {
          if (response.status === 200) {
            getSettingsdata();
            toast({ type: SUCCESS, message: response.data.message });
            setCards(
              cards.map((card, i) =>
                i === index
                  ? { ...card, formData: { head: "", key: "", value: "" } }
                  : card,
              ),
            );
          }
        })
        .catch((error) => {
          error.response
            ? toast({ type: ERROR, message: error.response.data.message })
            : toast({ type: ERROR, message: error.message });
        });
    } else {
      api
        .post("/settings/", formData, adminReqConfig())
        .then((response) => {
          if (response.status === 200) {
            getSettingsdata();
            toast({ type: SUCCESS, message: response.data.message });
            setCards(
              cards.map((card, i) =>
                i === index
                  ? { ...card, formData: { head: "", key: "", value: "" } }
                  : card,
              ),
            );
          }
        })
        .catch((error) => {
          error.response
            ? toast({ type: ERROR, message: error.response.data.message })
            : toast({ type: ERROR, message: error.message });
        });
    }
  };

  const onEditDelete = () => {
    getSettingsdata();
  };

  return (
    <AdminHeader title={"SETTINGS"}>
      <div className="fixed-top-bar" style={{ marginBottom: "10%" }}>
        {/* Quick Access Cards - renders once */}
        <QuickAccessCards
          cards={cards}
          setCards={setCards}
          onSelectCategory={handleSelectCategory}
          selectedCategory={selectedCategory}
        />

        {/* Table View for selected category */}
        {selectedCategory && (
          <SettingsTable
            category={selectedCategory}
            data={filteredData}
            onEdit={handleEditClick}
            onDelete={handleDelete}
            onAdd={handleAddNew}
          />
        )}

        {/* Old collapsible card view (kept for backward compatibility) */}
        {!selectedCategory && (
          <div>
            {cards?.map((card, index) => {
              let data = settingsData?.filter((f) => f.head === card.head);
              return (
                <SettingsCard
                  cards={cards}
                  setCards={setCards}
                  toast={toast}
                  data={data}
                  key={index}
                  index={index}
                  header={card.head}
                  formData={card.formData}
                  handleChange={handleChange}
                  handleSubmit={handleSubmit}
                  open={card.open}
                  toggleOpen={toggleOpen}
                  onEditDelete={onEditDelete}
                />
              );
            })}
          </div>
        )}

        {/* Add/Edit Modal - Updated with saving prop */}
        <SettingsModal
          show={isModalOpen}
          handleClose={handleCloseModal}
          handleSubmit={handleModalSubmit}
          formData={modalFormData}
          handleChange={handleModalChange}
          isEdit={isEdit}
          category={selectedCategory}
          saving={saving}
        />
      </div>
    </AdminHeader>
  );
};

export default SettingsList;
